module.exports = function (form) {
    var $form = form.getFormElem();

    var uri = URI(window.location.href);
    var query = URI.parseQuery(uri._parts.query);

    var queryKeys = Object.keys(query);

    for (var i = 0; i < queryKeys.length; i++) {
        var queryKey = queryKeys[i];
        var $input = $form.find('#' + queryKey);
        if ($input.length) {
            $input.addClass('not-empty');
        }
    }

    $form.find('.mktoTextField, .mktoEmailField, .mktoTelField, textarea, select').each(function (i, elem) {
        var $input = $(elem);

        if ($input.hasClass('mktoFormElemProcessed')) {
            return;
        }

        $input.addClass('mktoFormElemProcessed');

        var $container = $input.closest('.mktoFieldWrap');
        var $originalLabel = $container.find('.mktoLabel').first();
        var placeholderText = $input.attr('placeholder');
        if (!placeholderText) {
            placeholderText = $originalLabel.text();
        }
        if (placeholderText.indexOf('*') === 0) {
            placeholderText = placeholderText.substr(1, placeholderText.length - 1);
        }
        if (placeholderText.indexOf(':') === placeholderText.length - 1) {
            placeholderText = placeholderText.substr(0, placeholderText.length - 1);
        }
        if ($(this).hasClass('mktoRequired')) {
            placeholderText += ' *';
        }
        $input.attr('placeholder', '');
        $originalLabel.remove();

        $container.append('<div class="form-input-placeholder">' + placeholderText + '</div>');

        $input.keyup(function () {
            if ($(this).val()) {
                $(this).addClass('not-empty');
            } else {
                $(this).removeClass('not-empty');
            }
        });
    });

    if ($form.find('.mktoCheckboxList')) {
        var $fieldsets = $form.find('fieldset');

        $fieldsets.each(function (fieldsetIndex, fieldset) {
            var $fieldset = $(fieldset);

            var $checkboxes = $fieldset.find('.mktoCheckboxList');

            $fieldset.append('<div class="mktoCheckboxListCol"></div>');

            var $checkboxListContainer = $fieldset.find('.mktoCheckboxListCol').first();

            $checkboxes.each(function (i, checkbox) {
                var $checkbox = $(checkbox);

                var $label = $checkbox.find('label').first();
                if ($label && !$label.text().length) {
                    $checkbox.find('label').remove();
                    var $siblingLabel = $checkbox.siblings('label');
                    $checkbox.append($siblingLabel);
                }

                $checkbox.append('<div class="checkbox"><div class="checkbox__inner"></div></div>');
            });

            if ($checkboxes.length > 1) {
                var $firstRow = $fieldset.find('.mktoFormRow').first().addClass('mktoFormRow--full-width');
                var $actualRows = $fieldset.find('.mktoFormRow:not(:first)');

                $checkboxListContainer.append($firstRow);
                $checkboxListContainer.append($actualRows);

                $actualRows.each(function (i, row) {
                    var $row = $(row);
                    var $cols = $($row.children('.mktoFormCol').get().reverse());

                    $cols.each(function (j, col) {
                        var $col = $(col);
                        var newRow = document.createElement('div');
                        var $newRow = $(newRow);
                        $newRow.addClass('mktoFormRow');
                        $newRow.append($col);
                        $newRow.insertAfter($row);
                    });

                    $row.remove();
                });
            }
        });

        if (!$fieldsets.length) {
            var $checkboxes = $form.find('.mktoCheckboxList');

            $checkboxes.each(function (i, checkbox) {
                var $checkbox = $(checkbox);

                $checkbox.append('<div class="checkbox"><div class="checkbox__inner"></div></div>');
            });
        }
    }

    $(window).resize();
};